/**
 * @prettier
 * @flow
 */
export function getRefreshTokenInLocalStorage(): string | void {
    const item = window.localStorage.getItem(KEY_NAME);
    return item ? JSON.parse(item) : undefined;
}

export const KEY_NAME = 'refreshToken';
